import { API_BASE_URL, getHeaders, handleResponse } from '../apiConfig';

export const fetchInstitutions = async (params = {}) => {
  const query = new URLSearchParams();
  if (params && typeof params === 'object') {
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null && params[key] !== '') {
        query.append(key, params[key]);
      }
    });
  }
  const queryString = query.toString() ? `?${query.toString()}` : '';
  const response = await fetch(`${API_BASE_URL}/institutions${queryString}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const createInstitution = async (data) => {
  const response = await fetch(`${API_BASE_URL}/institutions`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const updateInstitution = async (id, data) => {
  const response = await fetch(`${API_BASE_URL}/institutions/${id}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify(data)
  });
  return handleResponse(response);
};

export const deleteInstitution = async (id) => {
  const response = await fetch(`${API_BASE_URL}/institutions/${id}`, {
    method: 'DELETE',
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchInstitutionCandidateComparison = async (id, medium) => {
  const query = medium && medium !== 'all' ? `?medium=${encodeURIComponent(medium)}` : '';
  const response = await fetch(`${API_BASE_URL}/institutions/${id}/candidate-comparison${query}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

export const fetchInstitutionsComparisonOverview = async (medium) => {
  const query = medium && medium !== 'all' ? `?medium=${encodeURIComponent(medium)}` : '';
  const response = await fetch(`${API_BASE_URL}/institutions/candidate-comparison-overview${query}`, {
    headers: getHeaders()
  });
  return handleResponse(response);
};

